@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.secondaryText {
  @include typography-v2-body-xs;
  color: var(--text-soft);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trackingStatus {
  color: var(--text-soft);

  &.isTracking {
    color: var(--viz-bullish);
  }
}

.errorWrapper {
  display: flex;
  align-items: center;
  gap: 4px;
}

.errorText {
  @include typography-v2-body-xs;
  color: var(--text-warning);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;

  &.read {
    color: var(--text-soft);
  }
}

.alfredLogo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  @include border-radius-full;
  background-color: var(--background-default);
}
